<script>
	const Q = require('q');
	const _ = require('underscore');
	const moment = require('moment');
	const model = require('model/model');
	const studentProgressUtilities = require('utilities/studentProgressUtilities');
	const classUtilities = require('utilities/classUtilities');
	const getBigBookOfKnowledge = classUtilities.getBigBookOfKnowledge;
	const utilities = require('utilities');
	const getWordCount = utilities.getWordCount;

	const assignmentService = require('services/assignmentService');

	const classBOKUtilities = require('utilities/classBOKUtilities');
	const getStudentCbokEntries = classBOKUtilities.getStudentEntries;
	const addToClassBoK = classBOKUtilities.create;
	const removeFromClassBoK = classBOKUtilities.remove;

	const alertUtilities = require('utilities/alertUtilities');
	const success = alertUtilities.success;

	const { fireEvent, events } = require('utilities/analyticsUtilities');
	const CBOK_POST_STUDENT_ENTRY = events.CBOK_POST_STUDENT_ENTRY;
	const CBOK_REMOVE_STUDENT_ENTRY = events.CBOK_REMOVE_STUDENT_ENTRY;

	const { assetUrl } = require('utilities/urlUtilities');
	const pubsub = require('events/pubsub');

	module.exports = {
		components: {
			'book-of-knowledge-assignment': require('components/book-of-knowledge-assignment.vue').default,
			'book-of-knowledge-entry': require('components/book-of-knowledge-entry.vue').default,
			'bok-bookmark-icon': require('components/svg/bok-bookmark-icon.vue').default,
			'bok-note': require('components/bok-note.vue').default
		},
		props: {
			assignments: {
				default: []
			},
			currentClass: {
				default: null
			},
			studentName: {
				default: null
			},
			suid: {
				default: null
			},
			generateAssignmentLink: {
				default: null,
				type: Function
			},
			onTitleClick: {
				default() {},
				type: Function
			},
			onArticleClick: {
				default: null,
				type: Function
			},
			loading: {
				default: false
			},
			bokNoteEditable: {
				default: false
			},
			hideMonthPicker: {
				default: false
			}
		},
		modelData: {
			bigBok: 'bigBok',
			userContext: 'userContext',
			bigBokMonth: 'month',
			studentProgressMonth: 'studentProgressMonth',
			studentId: 'studentId',
			activeClass: 'activeClass',
			studentCbok: 'studentCbok'
		},
		data() {
			return {
				fetchingBigBok: false,
				totalArticles: 0,
				articlesRead: 0,
				wordsWritten: 0,
				wordsRead: 0,
				studentCbokLoading: false,
				cbokActionInProgress: null
			};
		},
		computed: {
			monthText() {
				let month = this.month;
				let monthText = '';
				if (month !== 'all') {
					let date = moment([new Date().getFullYear(), month]);
					monthText = date.format('MMMM');
				}
				return monthText;
			},
			startDate: function () {
				let month = this.month;
				return studentProgressUtilities.getStartDate(month);
			},
			endDate: function () {
				let month = this.month;
				let endDate = studentProgressUtilities.getEndDate(month);
				let now = new Date().getTime();

				if (endDate > now) {
					endDate = now;
				}

				return endDate;
			},
			monthList() {
				const userContext = this.userContext;
				const currentClass = this.currentClass;
				let createdTS = 0;
				let monthList = null;

				if (userContext && userContext.created) {
					createdTS = userContext.created * 1000;
				} else if (currentClass && currentClass.created) {
					createdTS = currentClass.created * 1000;
				}
				if (typeof createdTS === 'number') {
					monthList = studentProgressUtilities.getMonthList(createdTS);
					monthList.push({
						text: 'See All',
						value: 'all'
					});
				}
				return monthList;
			},
			assignmentsByAid() {
				let assignments = this.assignments;
				let assignmentsByAid = null;

				if (assignments) {
					assignmentsByAid = assignments.reduce((acc, a) => {
						let aid = a.aid || a.assignmentId;
						acc[aid] = a;
						return acc;
					}, {});
				}

				return assignmentsByAid;
			},
			/* eslint-disable no-unused-vars */
			entries() {
				let bigBok = this.bigBok;
				let assignmentsByAid = this.assignmentsByAid;
				let studentCbok = this.studentCbok;
				let entries = this.computeBigBok();

				return entries;
			},
			/* eslint-enable no-unused-vars */
			editBoKInline() {
				return this.activeClass && this.activeClass.as.bokEdit;
			},
			editable() {
				return !this.studentName;
			},
			isLoading() {
				let loading = this.loading;
				let fetchingBigBok = this.fetchingBigBok;
				let studentCbokLoading = this.studentCbokLoading;

				return loading || fetchingBigBok || studentCbokLoading;
			},
			loaderImageSrc() {
				return assetUrl('/assets/dist/images/loader.gif');
			}
		},
		methods: {
			fetchBigBok: _.debounce(function () {
				let startDate = this.startDate;
				let endDate = this.endDate;
				this.fetchingBigBok = true;

				this.totalArticles = 0;
				this.articlesRead = 0;
				this.wordsWritten = 0;

				getBigBookOfKnowledge(startDate, endDate).then(() => (this.fetchingBigBok = false));
			}, 1),
			computeBigBok() {
				let bigBok = this.bigBok;
				let assignmentsByAid = this.assignmentsByAid;
				let entries = [];

				let totalArticles = 0;
				let articlesRead = 0;
				let wordsWritten = 0;

				let studentCbok = this.studentCbok;

				if (assignmentsByAid && bigBok && bigBok.length) {
					bigBok.forEach(bok => {
						if (bok && bok.aid) {
							let aid = bok.aid;
							let assignment = assignmentsByAid[aid];
							let pmd = assignment ? assignment.pmd || assignment.productMetaData : null;
							let cbokEntriesByArticle = {};

							if (studentCbok && studentCbok[aid]) {
								let cbokEntries = studentCbok[aid].a;
								if (cbokEntries) {
									let articleEntries = Object.keys(cbokEntries);
									articleEntries.forEach(pid => {
										cbokEntriesByArticle[pid] = cbokEntries[pid];
									});
								}
							}
							if (pmd) {
								let includeInBigBok = false;
								let workspaces = bok.sc && bok.sc.a ? bok.sc.a : null;
								let articles = workspaces ? Object.keys(workspaces) : [];
								let options = assignment.opts || assignment.options;
								let assigned = false;
								if (options) {
									assigned = options.bok || options.assignBookOfKnowledge;
								}

								if (articles.length) {
									// Check for bok entries
									// if entries, count words and articles read
									// and words written
									let sortedWorkspaces = articles.reduce((acc, pid) => {
										let articleWorkspace = workspaces[pid];
										if (articleWorkspace && articleWorkspace.s === 's') {
											includeInBigBok = true;
											articlesRead += 1;

											if (articleWorkspace.b && articleWorkspace.b.length) {
												wordsWritten += getWordCount(articleWorkspace.b);
											}
											if (articleWorkspace.brev && articleWorkspace.brev.length) {
												wordsWritten += getWordCount(articleWorkspace.brev);
											}
											if (pmd.allArticles[pid]) {
												// Add AID, PID to article metadata
												pmd.allArticles[pid] = _.assign({}, pmd.allArticles[pid], {
													pid,
													aid
												});
											}

											acc.push(
												_.assign({}, articleWorkspace, {
													pid,
													aid,
													inCbok: cbokEntriesByArticle[pid],
													id: aid + pid
												})
											);
										}
										return acc;
									}, []);

									sortedWorkspaces.sort((a, b) => b.tf - a.tf);

									if (includeInBigBok) {
										totalArticles += articles.length;
										entries.push(
											_.assign({}, bok, {
												pmd,
												assigned,
												workspaces: sortedWorkspaces,
												d: assignment.d,
												ed: assignment.ed
											})
										);
									}
								}
							}
						}
					});
					entries.sort((a, b) => b.d - a.d);
				}

				this.totalArticles = totalArticles;
				this.articlesRead = articlesRead;
				this.wordsWritten = wordsWritten;

				return entries;
			},
			getAssignmentLink(entry) {
				if (this.generateAssignmentLink && entry && entry.aid) {
					return this.generateAssignmentLink(entry.aid);
				}
				return null;
			},
			onMonthSelect() {
				this.studentProgressMonth = this.month;
			},
			editBoKEntry(entry, bok, persist, editRevision) {
				let ts = Date.now() / 1000;
				let endpointName = 'reviseBookOfKnowledge';
				let contentKey = 'brev';
				let tsKey = 'brevts';
				let pid = entry ? entry.pid : null;
				let aid = entry ? entry.aid : null;
				let updatedData = {};
				let prms = Q();
				let bigBok = this.bigBok;

				if (!editRevision) {
					endpointName = 'editBookOfKnowledge';
					contentKey = 'b';
					tsKey = 'bets';
				}

				// persisting to memory cause re-rendering of the entry component
				// only to be done on submit
				if (persist) {
					updatedData[contentKey] = bok;
					updatedData[tsKey] = ts;

					let updatedBigBok = bigBok.map(assignment => {
						if (assignment.aid === aid) {
							assignment.sc.a[pid] = _.assign({}, assignment.sc.a[pid], updatedData);
						}
						return assignment;
					});
					model.set('bigBok', updatedBigBok);
				} else if (aid) {
					// persisting to service is done on ever change event
					prms = assignmentService[endpointName]({
						aid,
						pid,
						bok
					});
				}

				return prms;
			},
			onClassChange(cc) {
				let suid = this.suid;
				this.studentCbokLoading = true;
				getStudentCbokEntries(cc, suid).finally(() => (this.studentCbokLoading = false));
			},
			addToCbok(entry) {
				let aid = entry.aid;
				let cc = this.currentClass && this.currentClass.classCode;
				let uid = this.suid;
				let a = entry.pid;
				let suids = [uid];

				this.cbokActionInProgress = entry.id;

				fireEvent(CBOK_POST_STUDENT_ENTRY, {
					cc,
					aid,
					suids,
					pid: a
				});
				addToClassBoK(aid, cc, suids, a, entry)
					.then(() => getStudentCbokEntries(cc))
					.finally(() => {
						success('Entry added to the Class Book of Knowledge');
						this.cbokActionInProgress = null;
					});
			},
			removeFromCbok(entry) {
				let id = entry.id;
				let aid = entry.aid;
				let cc = this.currentClass && this.currentClass.classCode;
				let uid = this.suid;
				let a = entry.pid;

				this.cbokActionInProgress = entry.id;

				fireEvent(CBOK_REMOVE_STUDENT_ENTRY, {
					cc,
					aid,
					pid: a,
					suids: [uid]
				});
				removeFromClassBoK(id, aid, a, cc, uid)
					.then(() => getStudentCbokEntries(cc))
					.finally(() => {
						success('Entry removed from the Class Book of Knowledge');
						this.cbokActionInProgress = null;
					});
			},
			setTeacherNote(workspace, value) {
				assignmentService
					.setBoKNote({
						uid: this.suid,
						a: workspace.pid,
						aid: workspace.aid,
						tn: value
					})
					.then(() => {
						pubsub.publish('assessment-needs-reload');
					});
			}
		},
		watch: {
			studentProgressMonth(month) {
				if (month !== undefined) {
					this.month = month;
					this.fetchBigBok();
				}
			},
			studentId() {
				this.fetchBigBok();
			},
			activeClass(val) {
				if (val && val.cc) {
					this.onClassChange(val.cc);
				}
			},
			currentClass(val) {
				if (val && val.classCode) {
					this.onClassChange(val.classCode);
				}
			}
		},
		mounted() {
			if (this.studentProgressMonth !== undefined) {
				this.month = this.studentProgressMonth;
			} else {
				this.month = this.month || studentProgressUtilities.getCurrentMonth();
			}

			this.fetchBigBok();
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';
	@import 'mixins/flexbox';

	.bok-stats {
		text-align: right;

		.bok-stat {
			text-align: left;
			font-weight: 500;
		}

		.bok-stat-subtitle {
			text-align: left;
			font-size: 0.75rem;
			text-transform: uppercase;
		}

		> * {
			display: block;
			margin: 0 $size-small;
		}
	}

	.big-book-of-knowledge {
		.big-bok-toolbar {
			padding-bottom: 1rem;

			.big-bok-tools {
				flex: 1;
				display: flex;
				align-items: center;

				.date-select {
					margin-bottom: 1rem;
				}
			}
		}
	}

	@media print {
		.big-book-of-knowledge {
			.big-bok-toolbar .big-bok-tools {
				display: block;

				h2.print-only {
					margin-bottom: 0;
					display: block;
				}

				h3.print-only {
					margin-top: 0;
					display: block;
				}
			}

			div a {
				display: inherit !important;
			}

			.assignment-container .card-container > .bok-entry {
				max-width: 100%;
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.big-book-of-knowledge {
			.big-bok-toolbar {
				display: flex;
				align-items: center;

				.big-bok-tools .date-select {
					margin-bottom: 0;
				}
			}
		}

		.bok-stats {
			> * {
				display: inline-block;
			}
		}
	}
</style>
<template>
	<div class="big-book-of-knowledge">
		<div class="big-bok-toolbar">
			<div class="form big-bok-tools">
				<div
					v-if="!hideMonthPicker"
					class="date-select input-select slim print-hidden">
					<select
						v-model="month"
						@change="onMonthSelect"
						class="input">
						<option
							v-for="month in monthList"
							:value="month.value"
							:key="month.value">
							{{ month.text }}
						</option>
					</select>
				</div>
				<h2 class="print-only">Big Book of Knowledge</h2>
				<h3
					v-if="monthText"
					class="print-only">
					{{ monthText }}
				</h3>
			</div>
			<div class="bok-stats">
				<div>
					<div class="bok-stat">{{ articlesRead }} of {{ totalArticles }}</div>
					<div class="bok-stat-subtitle text-muted font-small">Articles read</div>
				</div>
				<div>
					<div class="bok-stat">{{ wordsWritten | commaGrouping }}</div>
					<div class="bok-stat-subtitle text-muted font-small">Words written</div>
				</div>
			</div>
		</div>
		<template v-if="!isLoading">
			<book-of-knowledge-assignment
				v-for="entry in entries"
				:key="entry.aid"
				:assignment="entry"
				:get-header-link="getAssignmentLink"
				:on-header-click="onTitleClick">
				<div
					v-if="entry.workspaces"
					slot="entry-container"
					class="card-container">
					<book-of-knowledge-entry
						v-for="workspace in entry.workspaces"
						:key="workspace.uid"
						:entry="workspace"
						:article="entry.pmd.allArticles && entry.pmd.allArticles[workspace.pid]"
						:editable="!studentCbokLoading && !workspace.inCbok && editable"
						:assigned="!!entry.assigned"
						:student="(studentName && !workspace.name && { name: studentName }) || null"
						:inline-edit="editBoKInline"
						:on-article-click="onArticleClick"
						:on-edit="editBoKEntry">
						<template slot="actions-left">
							<button
								v-if="!suid && workspace.inCbok"
								class="entry-promoted button -link"
								v-tooltip="'Congratulations! Your entry has been chosen for the Class Book of Knowledge.'">
								<bok-bookmark-icon></bok-bookmark-icon>
							</button>
						</template>
						<template slot="actions">
							<div
								v-if="suid"
								class="add-to-cbok"
								:class="{
									'in-cbok': workspace.inCbok
								}">
								<img
									v-if="cbokActionInProgress === workspace.id"
									:src="loaderImageSrc"
									class="loading-indicator"
									role="status"
									alt="Loading" />
								<button
									v-if="cbokActionInProgress !== workspace.id"
									class="button -link"
									:aria-label="`${workspace.inCbok ? 'Remove from' : 'Add to'} Class Book of Knowledge`"
									@click="workspace.inCbok ? removeFromCbok(workspace) : addToCbok(workspace)">
									<bok-bookmark-icon></bok-bookmark-icon>
								</button>
							</div>
							<bok-note
								v-if="workspace.tn || bokNoteEditable"
								:editable="bokNoteEditable"
								@change-note="note => setTeacherNote(workspace, note)"
								:student-name="studentName ? studentName : workspace.name"
								:value="workspace.tn"></bok-note>
						</template>
					</book-of-knowledge-entry>
				</div>
			</book-of-knowledge-assignment>
			<div v-if="!entries || !entries.length">
				{{ studentName ? studentName + ' has' : 'You have' }} no Book of Knowledge entries{{ monthText ? ' for ' + monthText : '' }}.
			</div>
		</template>
		<div v-if="isLoading">Sit tight, your Book of Knowledge is loading!</div>
	</div>
</template>
